export default function BrandIntro() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
              品牌故事
            </h2>
            <div className="space-y-4 text-foreground-600 leading-relaxed">
              <p>
                精品一区成立于2020年，怀着"让优质内容触手可及"的初心，我们汇聚了一批热爱内容、追求极致的编辑团队。在信息爆炸的时代，我们坚持做减法——从海量信息中精心筛选出真正有价值的文章，为读者节省时间，提供高质量的阅读体验。
              </p>
              <p>
                我们的编辑团队来自不同领域的资深从业者，包括科技记者、文学编辑、商业分析师、文化研究者等。每一位编辑都以其专业眼光和严谨态度，确保平台上每一篇文章都经过精心挑选和深度打磨。
              </p>
              <p>
                四年多来，精品一区已发展成为拥有超过86万忠实读者的优质内容平台。我们与超过200位优质内容创作者建立了长期合作关系，累计发布了1500余篇精品文章，涵盖科技前沿、生活美学、人文社科、商业财经、健康养生、文化艺术六大领域。
              </p>
            </div>

            <div className="grid grid-cols-3 gap-6 mt-10">
              {[
                { value: '2020', label: '创立年份' },
                { value: '86万+', label: '忠实读者' },
                { value: '1500+', label: '精品文章' },
              ].map((item) => (
                <div key={item.label} className="text-center p-4 bg-background-100 rounded-lg">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">{item.value}</div>
                  <div className="text-xs text-foreground-500">{item.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimal%20office%20team%20working%20together%20on%20content%20creation%20with%20warm%20lighting%2C%20clean%20aesthetic%2C%20cream%20and%20warm%20wood%20tones%2C%20editorial%20photography&width=800&height=600&seq=about-brand-image&orientation=landscape"
                alt="精品一区编辑团队在工作"
                title="精品一区编辑团队"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}